import { useTranslation } from "react-i18next";
import AppRadioButton from "../../../../components/commons/AppRadioButton";
import { useAppDispatch } from "../../../../store/hook";
import { useEffect, useState } from "react";
import { VariablesConstant } from "../../../../constants/variables";
import Dcs0301Service from "../../../../services/dcs/Dcs0301Service";
import { showAndHideSpinner } from "../../../../reducers/spinnerSlice";
import { toast } from "react-toastify";
import { ExceptionConstant } from "../../../../constants/exceptionConstant";
import { InputSwitch } from "primereact/inputswitch";

export default function AddVersionForm(props: any) {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const [version, setVersion] = useState<any>({});
  const [status, setStatus] = useState<any>(VariablesConstant.ACTIVE_STATUS);

  useEffect(() => {
    if (props.data.isCreate) {
      setVersion({ ...version, protId: props.data.protocol.id, protNm: props.data.protocol.protNm, status: VariablesConstant.DEFAULT_ACTIVE_STATUS });
    } else {
      setVersion(props.data.version);
    }
  }, []);

  const handleChange = (event: any) => {
    setVersion({
      ...version,
      [event.target.name]: event.target.value,
    });
  };

  const changeStatus = (data?: any) => {
    if (data.value) {
      setVersion({ ...version, status: VariablesConstant.ACTIVE_STATUS_VAL });
    } else {
      setVersion({ ...version, status: VariablesConstant.INACTIVE_STATUS_VAL });
    }
  };

  function onSave(event: any) {
    event.preventDefault();
    if (chk(version)) {
      if (props.data.isCreate) {
        create();
      } else {
        update();
      }
    }
  }

  const create = () => {
    dispatch(showAndHideSpinner(true));
    Dcs0301Service.getInstance()
      .insertVersion(version)
      .finally(() => {
        setTimeout(() => {
          dispatch(showAndHideSpinner(false));
        }, 500);
      })
      .then((resp) => {
        if (resp.data.status) {
          toast.success(`${t("dcs0301.message.success.saveVersion")}`);
          props.onClose(true);
        } else {
          if (resp.data.message === ExceptionConstant.VERSION_EXISTED) {
            toast.error(`${t("dcs0301.message.err.versionExisted")}`);
          } else if (resp.data.message === ExceptionConstant.VERSION_NOT_AVAILABLE) {
            toast.error(`${t("dcs0301.message.err.versionNotAvailable")}`);
          } else {
            toast.error(`${t("dcs0301.message.err.save")}`);
          }
        }
      })
      .catch((error) => {
        toast.error(`${t("dcs0301.message.err.saveVersion")}`);
      });
  };

  const update = () => {
    dispatch(showAndHideSpinner(true));
    Dcs0301Service.getInstance()
      .updateVersion(version)
      .finally(() => {
        setTimeout(() => {
          dispatch(showAndHideSpinner(false));
        }, 500);
      })
      .then((resp) => {
        if (resp.data.status) {
          toast.success(`${t("dcs0301.message.success.updateVersion")}`);
          props.onClose(true);
        } else {
          if (resp.data.message === ExceptionConstant.VERSION_EXISTED) {
            toast.error(`${t("dcs0301.message.err.versionExisted")}`);
          } else if (resp.data.message === ExceptionConstant.VERSION_NOT_AVAILABLE) {
            toast.error(`${t("dcs0301.message.err.versionNotAvailable")}`);
          } else {
            toast.error(`${t("dcs0301.message.err.save")}`);
          }
        }
      })
      .catch((error) => {
        toast.error(`${t("dcs0301.message.err.updateVersion")}`);
      });
  };

  function chk(params: any) {
    let _chk = true;
    if (params.ver == null || params.ver.trim() === "") {
      toast.error(`${t("dcs0301.required.message.ver")}`);
      _chk = false;
    }

    if (!_chk) {
      setVersion((prevState: any) => {
        return {
          ...prevState,
          ver: prevState.ver || "",
          status: prevState.status || false,
        };
      });
    }
    return _chk;
  }

  return (
    <>
      <form onSubmit={onSave}>
        <div className="box">
          <div className="box-body">
            <div className="form-container">
              <div className="row align-items-center">
                <div className="col-lg-2 form-label-grid">
                  <label htmlFor="validationVer" className="form-label">
                    {t("dcs0301.form.label.ver")}
                    <strong className="strong-required"> *</strong>
                  </label>
                </div>
                <div className="col-lg-10">
                  <input value={version.ver || ""} placeholder={t("dcs0301.form.placeholder.ver")} className="form-control" name="ver" id="validationVer" onChange={handleChange}></input>
                </div>
              </div>

              <div className="row align-items-center border-bottom">
                <div className="col-lg-2 form-label-grid">
                  <label className="form-label">
                    {t("sys0301.table.header.status")} <strong className="strong-required"></strong>
                  </label>
                </div>
                <div className="col-lg-10 d-flex align-items-center gap-2">
                  {/* <AppRadioButton isHorizontal dataSource={status} nameGroup="status" onChange={changeStatus} value={{ value: version.status }} /> */}
                  <InputSwitch checked={version.status === VariablesConstant.ACTIVE_STATUS_VAL ? true : false} onChange={changeStatus} />
                  <span>{version.status === VariablesConstant.ACTIVE_STATUS_VAL ? "Active" : "Inactive"}</span>
                </div>
              </div>

              <div className="d-flex gap-3 mt-3 align-items-center justify-content-end">
                <button type="submit" className="custom-btn gradient">
                  <i className="pi pi-save fs-16 me-2"></i>
                  {t("confirm.button.save.text")}
                </button>
                <button type="button" onClick={() => props.onClose(false)} className="custom-btn">
                  <i className="pi pi-times fs-16 me-2"></i>
                  {t("confirm.button.cancel.text")}
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </>
  );
}
